/**
 * 属性ツリー上の「レイアウト」フィールド (背景・構図 composition 直下の group・migration 20261019_01)。
 * 選択肢を持たない「固定フィールド」で、生成画面ではバナーレイアウトの入口 (BannerLayoutEntry) を描く。
 * org-admin ではこのノードの非表示・並び順・表示位置をパートナーが変えられる (選択肢の追加は不可)。
 * docs/features/banner-layout-template-plan.md §19
 */
export const BANNER_LAYOUT_NODE_KEY = 'banner_layout';
export const BANNER_LAYOUT_WIDGET = 'banner_layout';

type NodeLike = { key: string; metadata?: Record<string, unknown> | null };

/** metadata.widget (正本) か key のどちらかで判定する。platform 管理者が key を変えても入口が消えないように両方見る */
export function isBannerLayoutNode(node: NodeLike): boolean {
  return node.metadata?.widget === BANNER_LAYOUT_WIDGET || node.key === BANNER_LAYOUT_NODE_KEY;
}
